import { forwardRef } from 'preact/compat'
import { globalState } from '@/components/helpers/utils'

export const SearchInput = forwardRef(({ onInput, redirect }, ref) => {
  return (
    <input
      ref={ref}
      onInput={onInput}
      className="grow flex-1 field-input p-0 border-0 focus:border-0 tex-[1rem] leading-1"
      type="text"
      name="query"
      placeholder={globalState.search.searchDropdownPlaceholder || 'Search our range by colour, style, material...'}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          if (redirect) {
            window.location.href = redirect
          } else {
            window.location.href = `/search?query=${e.target.value}`
          }
        }
      }}
    />
  )
})
